import DataTableCellField from "@/components/data-table/components/DataTableCellField";
import { DirtyAwareCell } from "@/contexts/FormTableCellDirtyContext";
import { usePayrollVisitCountHoursCalculation } from "../hooks/usePayrollVisitCountHoursCalculation";

interface PayrollVisitCountCorrectedCellProps {
  entryId: string;
  hoursBoundToVisits?: boolean | null;
  mostFrequentPlannedVisitDuration?: string | null;
}

export default function PayrollVisitCountCorrectedCell({
  entryId,
  hoursBoundToVisits,
  mostFrequentPlannedVisitDuration,
}: PayrollVisitCountCorrectedCellProps) {
  const visitCountPath = `entries.${entryId}.visit_count_corrected`;
  const hoursPath = `entries.${entryId}.hours_worked_corrected`;

  usePayrollVisitCountHoursCalculation({
    visitCountPath,
    hoursPath,
    hoursBoundToVisits,
    mostFrequentPlannedVisitDuration,
  });

  return (
    <DirtyAwareCell fieldPath={visitCountPath}>
      <DataTableCellField name={visitCountPath} type="number" />
    </DirtyAwareCell>
  );
}
